import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { connect } from 'react-redux';
import { IEncaissementEdit, IEncaissementEditReduxProps, ITarget } from '../../types/interfaces';
import { editEncaissement } from '../../flux/actions/encaissementActions';
import { getBanks } from '../../flux/actions/bankActions';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import NotificationAdd from '../notification/NotificationAdd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faFileImage, faHandRock, faPen, faPlus, faSpinner, faSquare, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import { constants } from '../../types/constants';
import { getEncModeRegl } from '../../services/misc';
import DatePicker from "reactstrap-date-picker";
import { useDropzone } from 'react-dropzone';

const EncaissementEdit = ({
  modal,
  setModal,
  modalData,
  editEncaissement,
  getBanks,
  bank,
  user,
  auth
 }: IEncaissementEdit) => {
  const alert = useAlert();
  const { banks, loading: loadingBank } = bank;
  const { users } = user
  const [idValue, setIdValue] = useState(-1);
  const [rectoImages, setRectoImages] = useState<any[]>([]);
  const [versoImages, setVersoImages] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setRectoImages(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const { getRootProps: getRootProps2, getInputProps: getInputProps2, isDragActive: isDragActive2 } = useDropzone({
    accept: 'image/*',
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setVersoImages(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const modereglementOptions = [constants.MODE_REGL_CHEQUE, constants.MODE_REGL_VERSEMENT, constants.MODE_REGL_VIREMENT].map(e => ({value: e, label: getEncModeRegl(e)}));
  const [modeReglementValue, setModeReglementValue] = useState<any>(modereglementOptions[0]);
  const [tireparValue, setTireparValue] = useState('');
  const [refencaissementValue, setRefencaissementValue] = useState('');
  const [dateCValue, setDateCValue] = useState('');
  const [dateEValue, setDateEValue] = useState('');
  const selectBankOptions = banks.map(e => ({value: e, label: e.fullname}));
  const [bankValue, setBankValue] = useState<any>('');
  const [modalNotification, setModalNotification] = useState(false);
  const [modalNotificationData, setModalNotificationData] = useState<any>(undefined);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);
  
  const handleModeReglementChange = data => {
    setModeReglementValue(data || '');
  }
  
  const refencaissementChangeHandler = (e: ITarget) => setRefencaissementValue(e.target.value);

  const tireparChangeHandler = (e: ITarget) => {
    setTireparValue(e.target.value)
  }
  const dateCChangeHandler = (e, t) => {
    setDateCValue(e);
  };
  const dateEChangeHandler = (e, t) => {
    setDateEValue(e);
  };
  const handleBankChange = data => {
    setBankValue(data ? data.value : '');
  }
  
  useEffect(() => {
    getBanks();
  }, [getBanks]);

  const modalOpenedHandle = () => {
    if(modalData){
      setIdValue(modalData["id"]);
      setModeReglementValue(modereglementOptions.find(e => e.value === modalData["MODE_REGL"]) || '');
      setRefencaissementValue(modalData["REF_REGLEMENT"] || '')
      setTireparValue(modalData["TIRE_PAR"] || '')
      setDateCValue(modalData.DATE_PORTEFEUILLE.toString());
      setDateEValue(modalData.DATE_REGLEMENT.toString());
      setBankValue((modalData.IDBANQUE !== undefined && modalData.IDBANQUE !== null ? selectBankOptions.find(t => t.value?.id === modalData.IDBANQUE)?.value : selectBankOptions.find(t => t.value?.name === modalData.BANQUE)?.value) || '');
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setRectoImages([]);
    setVersoImages([]);
    setModeReglementValue('')
    setRefencaissementValue('')
    setTireparValue('')
    setDateCValue('')
    setDateEValue('')
    setBankValue('')
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success) => {
    if(success && !success.err){
      setReEnable(true);
      setModal(false);
      alert.success("Encaissement modifié avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(!idValue)
      return
    if(!modeReglementValue?.value){
      alert.error("Veuillez sélectionner le mode de Règlement");
      return
    }
    if(refencaissementValue === ''){
      alert.error("Veuillez saisir la Réf. Règlement");
      return
    }
    if(tireparValue === ''){
      alert.error("Veuillez saisir le champs \"Tiré par / Effectué par\"");
      return
    }
    if(dateCValue === '' || dateEValue === ''){
      alert.error("Veuillez sélectionner une date valide");
      return
    }
    if(bankValue === ''){
      alert.error("Veuillez sélectionner une banque");
      return
    }
    setDisableSubmit(true);

    const readFile = file =>
      new Promise<any>(resolve => {
        const reader = new FileReader()
        reader.onload = function() {
          let codedBuffer = ""
          new Uint8Array(this.result as ArrayBuffer).forEach(byte => {
            codedBuffer += String.fromCharCode(byte)
          })
          resolve({codedBuffer})
        }
        reader.readAsArrayBuffer(file)
      })

    const uploadCallback = (uploadR: any = undefined, uploadV: any = undefined) => editEncaissement(idValue, modeReglementValue.value, refencaissementValue, tireparValue, new Date(dateCValue), new Date(dateEValue), bankValue["id"], bankValue["name"], uploadR, uploadV, callback);
    // if(rectoImages?.length){
    //   var reader = new FileReader();
    //   reader.onload = function() {
    //     var arrayBuffer = this.result,
    //       codedBuffer: string = "";
    //     (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
    //         codedBuffer += String.fromCharCode(byte);
    //     });
    //     uploadCallback({codedBuffer})
    //   }
    //   reader.readAsArrayBuffer(rectoImages[0]);
    // }
    // else
    //   uploadCallback()

    const rectoPromise = rectoImages?.[0] ? readFile(rectoImages[0]) : Promise.resolve(undefined)
    const versoPromise = versoImages?.[0] ? readFile(versoImages[0]) : Promise.resolve(undefined)

    Promise.all([rectoPromise, versoPromise]).then(([recto, verso]) => uploadCallback(recto, verso))
  };

  const openNotificationAdd = (userId, encaissement) => {
    setModalNotificationData({
      defaultType: 2,
      defaultTitle: "Encaissement mal saisi",
      defaultDescription: `${getEncModeRegl(encaissement.MODE_REGL)}, N° ${encaissement.REF_REGLEMENT}, Montant ${Number(encaissement.MONTANT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH, Dossier N° ${encaissement.contrat_encaissements?.[0]?.contrat?.NUM_DOSS || "-"}${encaissement.contrat_encaissements?.[0]?.contrat?.TRANCHE ? `, Tranche ${encaissement.contrat_encaissements?.[0]?.contrat?.TRANCHE}` : ""}, ${encaissement.contrat_encaissements?.[0]?.contrat?.PROJET}.\n\nIl est important de veiller à la bonne saisie des encaissements, car toute erreur fausse les rapports transmis au siège et peut avoir de graves conséquences.`,
      defaultUsersIds: [userId]
    })
    setModalNotification(true)
  }

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modification de l'encaissement</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              {!!modalData && <>
                <Row>
                  <Col xs="12" style={{fontWeight: 600}}>Envoyer un message d'avertissement</Col>
                </Row>
                <Row style={{borderBottom: "2px dashed #999", paddingBottom: "15px", marginBottom: /*"15px"*/"10px"}}>
                  <Col xs="12" md="6" style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
                    <div>Au commercial</div>
                    <Button className="btn-sm btn-info" onClick={() => openNotificationAdd(modalData.ID_COM, modalData)}>{users.find(e => e.id === modalData.ID_COM)?.username || "-"}</Button>
                  </Col>
                  <Col xs="12" md="6" style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
                    <div>Au saisisseur</div>
                    <Button className="btn-sm btn-info" onClick={() => openNotificationAdd(modalData.SAISIE_PAR_ID, modalData)}>{users.find(e => e.id === modalData.SAISIE_PAR_ID)?.username || "-"}</Button>
                  </Col>
                </Row>
              </>}
              <Row>
                <Col xs="12" className="fullFlexCenter" style={{fontSize: "large", fontWeight: 500, color: "#333"}}>
                  <FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modification de l'encaissement
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label>Recto du {getEncModeRegl(modeReglementValue?.value, false) || "Chèque"}{modalData?.recto_name ? <div style={{display: "inline-block", color: "orangered"}}>&nbsp;- scan existant dans le système, voulez-vous le remplacer?</div> : ""}</Label>
                    <section>
                      <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                        <input {...getInputProps()} />
                        {rectoImages?.length ? <aside className="thumbContainer">
                          <div className="thumbDelete" onClick={e => (e.stopPropagation(), setRectoImages([]))} title="Supprimer le scan"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                          <div className="thumb" key={rectoImages[0].name}>
                            <div className="thumbInner">
                              <img src={rectoImages[0].preview} className="thumbImg" />
                            </div>
                          </div>
                        </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le scan <span style={{fontWeight: 600}}>Recto</span> ici</span>}
                      </div>
                    </section>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label>Verso du {getEncModeRegl(modeReglementValue?.value, false) || "Chèque"}{modalData?.verso_name ? <div style={{display: "inline-block", color: "orangered"}}>&nbsp;- scan existant dans le système, voulez-vous le remplacer?</div> : ""}</Label>
                    <section>
                      <div {...getRootProps2({className: `dropzone${isDragActive2 ? " dropzoneHovered" : ""}`})}>
                        <input {...getInputProps2()} />
                        {versoImages?.length ? <aside className="thumbContainer">
                          <div className="thumbDelete" onClick={e => (e.stopPropagation(), setVersoImages([]))} title="Supprimer le scan"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                          <div className="thumb" key={versoImages[0].name}>
                            <div className="thumbInner">
                              <img src={versoImages[0].preview} className="thumbImg" />
                            </div>
                          </div>
                        </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le scan <span style={{fontWeight: 600}}>Verso</span> ici</span>}
                      </div>
                    </section>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup style={{position: "relative"}}>
                    <Label for="modereglement">Mode de règlement</Label>
                    <Select
                      id="modereglement"
                      name="modereglement"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={modereglementOptions[0]}
                      value={modeReglementValue}
                      onChange={handleModeReglementChange}
                      isClearable={false}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={modereglementOptions}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="refencaissement">Réf. Règlement</Label>
                    <Input id="refencaissement" type="text" placeholder="Référence du règlement..." value={refencaissementValue} onChange={refencaissementChangeHandler} className="form-control" />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tirepar">{modeReglementValue?.value === constants.MODE_REGL_CHEQUE ? "Tiré" : "Effectué"} par</Label>
                    <Input id="tirepar" placeholder={`${modeReglementValue?.value === constants.MODE_REGL_CHEQUE ? "Tiré" : "Effectué"} par...`} value={tireparValue} onChange={tireparChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="cDatepicker">Date du {getEncModeRegl(modeReglementValue?.value, false) || "Chèque"}</Label>
                    <DatePicker id="cDatepicker"
                      value={dateCValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={(v,f) => dateCChangeHandler(v, f)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="eDatepicker">Date d'Encaissement (prolongation)</Label>
                    <DatePicker id="eDatepicker"
                      value={dateEValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={(v,f) => dateEChangeHandler(v, f)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="bank">Banque</Label>
                    <Select
                      id="bank"
                      name="bank"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={bankValue ? {label: bankValue["fullname"], value: bankValue} : null}
                      onChange={handleBankChange}
                      placeholder={'Chercher par nom...'}
                      isClearable={true}
                      isLoading={loadingBank}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='name'
                      options={selectBankOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center stickyBottom">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
      <NotificationAdd modal={modalNotification} setModal={setModalNotification} {...(modalNotificationData || {})} fromModal />
    </div>
  );
};

const mapStateToProps = (state: IEncaissementEditReduxProps) => ({
  bank: state.bank,
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editEncaissement, getBanks })(EncaissementEdit);
